import { Avatar, HStack, StackProps, Text, VStack } from "@chakra-ui/react";
import { ListChatInterface } from "../../constants/Chat";
import { useBgHover } from "../../themes/colors";

interface Props extends StackProps {
  item: ListChatInterface;
}

export const CardChat = ({ item, ...rest }: Props) => {
  const bgHover = useBgHover();

  return (
    <HStack
      w={"100%"}
      p={2}
      borderRadius={"md"}
      cursor={"pointer"}
      _hover={{ bg: bgHover }}
      {...rest}
    >
      <Avatar
        name={item?.name || ""}
        src={
          item?.avatar
            ? `${process.env.REACT_APP_MEDIA_URL}${item?.avatar}`
            : ""
        }
        objectFit={"cover"}
        size={"sm"}
      />

      <VStack
        gap={0}
        width={"100%"}
        noOfLines={1}
        textOverflow={"ellipsis"}
        align={"stretch"}
      >
        <Text textStyle={"b-reg-sb"} noOfLines={1} textOverflow={"ellipsis"}>
          {item.name}
        </Text>

        <Text
          textStyle={"b-sm"}
          variant={"secondary"}
          noOfLines={1}
          textOverflow={"ellipsis"}
        >
          {item.message}
        </Text>
      </VStack>
      <Text textStyle={"b-sm"} variant={"secondary"}>
        {getDateTime(item.created_at)}
      </Text>
    </HStack>
  );
};

const getDateTime = (date: string | Date) => {
  const dateObj = new Date(date);
  if (new Date().getTime() - dateObj.getTime() < 60000) {
    return "Baru";
  } else if (new Date().getDate() - dateObj.getDate() < 1) {
    return dateObj.toLocaleTimeString("id-ID", {
      hour: "2-digit",
      minute: "2-digit",
    });
  } else if (new Date().getDate() - dateObj.getDate() === 1) {
    return "Kemarin";
  } else if (new Date().getDate() - dateObj.getDate() < 7) {
    return dateObj.toLocaleDateString("id-ID", { weekday: "long" });
  }
  return dateObj.toLocaleDateString("id-ID", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};
